import { useSession } from 'next-auth/react';
import { useMutation, UseMutationResult } from 'react-query';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseMutationUpdateUserProfileData =
  Content.Endpoints.UpdateUserProfileResponse;

interface UseMutationUpdateUserProfileError {
  errors: any;
  message?: string;
}

interface UseMutationUpdateUserProfileParameters {
  data: Partial<Content.Requests.UpdateUserProfileRequestBody>;
  refreshSession?: boolean;
}

const useMutationUpdateUserProfile = () => {
  const locale = getLocale();
  const { data: session } = useSession();

  const mutation: UseMutationResult<
    UseMutationUpdateUserProfileData,
    UseMutationUpdateUserProfileError,
    UseMutationUpdateUserProfileParameters
  > = useMutation(
    async variables => {
      const fetchResponse = await fetch('/api/users/update-user-profile', {
        body: JSON.stringify({
          ...variables.data,
          refreshSession: variables.refreshSession,
        }),
        headers: {
          ['Accept-Language']: getCulture(locale),
          ['Content-Type']: 'application/json',
          ...(session?.user.accessToken
            ? { ['Authorization']: `Bearer ${session?.user.accessToken}` }
            : {}),
        },
        method: 'PUT',
      })
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .catch(error => {
          console.error('content.useMutationUpdateUserProfile', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      onError: async error => error,
    },
  );

  return mutation;
};

export default useMutationUpdateUserProfile;
